module.exports = __webpack_public_path__ + "static/img/hykecam.256980f.png";